import React, { FormEvent, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { validateEmail } from 'client/helpers/Form'
import { SUBSCRIBED, UNSUBSCRIBED } from 'src/effects/SubscriptionStatus/constants'
import { Button } from '@s4l/ds'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import styles from './styles.module.css'
import MessageTerms from 'client/components/MessageTerms'
import Input from 'src/comps/Atom/Inputs/Input/Input'
import messages from 'client/components/FormErrorMessage/messages'

interface INewsletterProps {
  readonly status: string
  readonly onSubscribe: (email: string) => void
}

export function SubscriptionModal(props: INewsletterProps) {
  const { status, onSubscribe } = props
  const [errors, setErrors] = useState<{ id: string }[]>([])
  const [email, setEmail] = useState('')
  const intl = useIntl()
  const [formSubmitted, setFormSubmitted] = useState(false)

  if (status === SUBSCRIBED) {
    return null
  }

  const handleChangeEmail = (newEmail: string) => {
    setEmail(newEmail)
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()

    setFormSubmitted(true)

    if (validateEmail(email)) {
      setErrors([{ id: 'validEmail' }])
      return
    }
    setErrors([])
    onSubscribe(email)
  }

  if (status === UNSUBSCRIBED) {
    return (
      <div className={styles.subscriptionModalBase}>
        <h6 className={styles.subscriptionModalTitle}>
          <FormattedMessage id="global.modal-home-subscription-title" />
        </h6>
        <p className={styles.subscriptionModalSubTitle}>
          <FormattedMessage id="global.modal-home-subscription-subtitle" />
        </p>
        <form
          className={styles.subscriptionForm}
          data-testid="subscription-form"
          onSubmit={handleSubmit}
        >
          <Input
            errors={errors.map(error => {
              const message = messages[error.id as keyof typeof messages]
              return intl.formatMessage(message)
            })}
            label={intl.formatMessage({ id: 'global.email' })}
            value={email}
            onChange={handleChangeEmail}
            disabled={formSubmitted && errors.length === 0}
          />
          <Button
            disabled={formSubmitted && errors.length === 0}
            variant="filled-rounded"
            trailingIcon={<IconArrowRight />}
            size="small"
            fullWidth
            type="submit"
          >
            <FormattedMessage id="global.modal-home-subscription-cta" />
          </Button>
        </form>

        <div className={styles.termsContainer}>
          <MessageTerms isEmail />
        </div>
      </div>
    )
  }

  return null
}
